module.exports = __webpack_public_path__ + "static/media/sfx_ui_pop_up_normal.bdb549f4.mp3";